module.exports = __webpack_public_path__ + "static/rph2rph-hero-1d2ba76a446d575befce8aab7a51ed15.svg";